<template>
  <div class="wscn-http444-container">
    <div class="wscn-http444">
      <div class="pic-444">
        <img
          class="pic-444__parent"
          src="@/assets/444.jpeg"
          alt="444"
        />
      </div>
      <div class="bullshit">
        <div class="bullshit__oops">注意!</div>
        <!-- <div class="bullshit__info">All rights reserved
          <a style="color:#20a0ff" href="https://wallstreetcn.com" target="_blank">wallstreetcn</a>
        </div> -->
        <div class="bullshit__headline">{{ message }}</div>
        <div class="bullshit__info">
          请检查您输入的URL是否正确，或者单击下面的按钮返回管理平台主页。
        </div>

        <div style="display: flex; flex-direction: column; align-items: center; justify-items: center">
          <div
            class="user-profile"
            style="width: 115px; border: 1px solid #dcdfe6; margin: 10px"
          >
            <div
              class="box-center"
              style="display: flex; flex-direction: column; align-items: center"
            >
              <el-avatar
                shape="square"
                :size="100"
                :src="avatar"
                icon="el-icon-user-solid"
              ></el-avatar>
            </div>
            <div class="box-center">
              <div class="user-name text-center">{{ name }}</div>
              <div class="user-role text-center text-muted">
                {{ roles?.join('|') }}
              </div>
            </div>
          </div>

          <div>
            <a @click="toWebSite" class="bullshit__return-home">前往管理平台</a>
            <a
              class="bullshit__return-home"
              style="margin-left: 10px"
              @click="signOutOidc"
              >重新登录</a
            >
          </div>
        </div>

        
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import config from '@/utils/config'
export default {
  name: "Page444",
  computed: {
    ...mapGetters("user", ["name", "avatar", "roles"]),
    message() {
      return "当前用户身份不为学生，不能访问当前页面...";
    },
    // webSite() {
    //   return process.env.VUE_APP_STUDENT_WEBSITE;
    // },
  },
  data() {
    return {
      imageUrl: undefined, // 头像路径
      webSite: '',
      //fileUrl: process.env.VUE_APP_FILE_URL,
    };
  },
  created() {
    this.fetchConfig();
  },
  methods: {
    ...mapActions("oidc", [
      "signOutOidc",
      "removeOidcUser"
    ]),
    toWebSite() {
      this.removeOidcUser();
      window.location.href = this.webSite;
    },
    async fetchConfig() {
      await config.getTeacherWebSite.then((res) => {
        this.webSite = res;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.wscn-http444-container {
  transform: translate(-50%, -50%);
  position: absolute;
  top: 40%;
  left: 50%;
}
.wscn-http444 {
  position: relative;
  width: 1200px;
  padding: 0 50px;
  overflow: hidden;
  .pic-444 {
    position: relative;
    float: left;
    width: 500px;
    overflow: hidden;
    &__parent {
      width: 100%;
    }
  }
  .bullshit {
    position: relative;
    float: left;
    width: 300px;
    padding: 45px 0;
    overflow: hidden;
    &__oops {
      font-size: 32px;
      font-weight: bold;
      line-height: 40px;
      color: #1482f0;
      opacity: 0;
      margin-bottom: 20px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-fill-mode: forwards;
    }
    &__headline {
      font-size: 20px;
      line-height: 24px;
      color: #222;
      font-weight: bold;
      opacity: 0;
      margin-bottom: 10px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.1s;
      animation-fill-mode: forwards;
    }
    &__info {
      font-size: 13px;
      line-height: 21px;
      color: grey;
      opacity: 0;
      // margin-bottom: 30px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.2s;
      animation-fill-mode: forwards;
    }
    &__return-home {
      display: block;
      float: left;
      width: 110px;
      height: 36px;
      background: #1482f0;
      border-radius: 100px;
      text-align: center;
      color: #ffffff;
      opacity: 0;
      font-size: 14px;
      line-height: 36px;
      cursor: pointer;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.3s;
      animation-fill-mode: forwards;
    }
    @keyframes slideUp {
      0% {
        transform: translateY(60px);
        opacity: 0;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
}

.user-profile {
  .user-name {
    font-weight: bold;
  }

  .box-center {
    padding-top: 10px;
  }

  .user-role {
    padding: 10px 0;
    font-weight: 400;
    font-size: 14px;
  }

  .box-social {
    padding-top: 30px;

    .el-table {
      border-top: 1px solid #dfe6ec;
    }
  }

  .user-follow {
    padding-top: 20px;
  }
}
</style>
